import axios from 'axios';

const endpoint = '/working-hours';
const entity = 'working-hours';
const key = 'id';

const state = {
  data: {},
};

const mutations = {
  data(state, value) {
    state.data = value;
  },
};

const actions = {
  async get({ commit }, params = '?$populate[0]=agents&$populate[1]=subscribers') {
    const response = await axios.get(`${endpoint}${params}`);
    commit('data', response.data);
  },
  find({}, id) {
    return new Promise((resolve, reject) => {
      axios.get(`${endpoint}/${id}`)
        .then(({ data }) => resolve(data))
        .catch(error => reject(error));
    });
  },
  async post({ dispatch }, body = {}) {
    const response = await axios.post(`${endpoint}`, body).catch(e => e);
    await dispatch('get');
    return response;
  },
  async patch({ dispatch }, { id, body = {} }) {
    const response = await axios.patch(`${endpoint}/${id}`, body).catch(e => e);
    await dispatch('get');
    return response;
  },
  delete({ dispatch }, id = '') {
    return new Promise((resolve, reject) => {
      axios.delete(`${endpoint}/${id}`)
        .then(({ data }) => {
          dispatch('get')
            .then(() => resolve({ entity, key, data }))
            .catch(error => reject(error));
        })
        .catch(error => reject(error));
    });
  },
  deletes({ dispatch }, array) {
    return new Promise((resolve, reject) => {
      array.map(async (id, index) => {
        await dispatch('delete', id).catch(reject);
        if (array.length - 1 === index) dispatch('get').then(() => resolve()).catch(() => reject());
      });
    });
  },
};

const getters = {
  data: state => state.data,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
